import { render } from "./dem_1.0.0.vue?vue&type=template&id=2a985127"
import script from "./dem_1.0.0.vue?vue&type=script&lang=ts"
export * from "./dem_1.0.0.vue?vue&type=script&lang=ts"
script.render = render

export default script